import { Box, Chip, Paper, Stack, Typography } from "@mui/material";

import { formatChannelLabel, getChannelChipStyles } from "../../../../lib/presentation";
import type { RankedRow } from "./purchaseBehaviorUtils";

export default function PurchaseBehaviorChannelPanel({ rows }: { rows: RankedRow[] }) {
    return (
        <Paper className="table-card" elevation={0}>
            <Box className="table-card__header">
                <Typography variant="h5">Канал</Typography>
            </Box>
            <Stack direction="row" spacing={1} sx={{ flexWrap: "wrap" }}>
                {rows.length === 0 ? (
                    <Typography color="text.secondary">Няма данни за канал.</Typography>
                ) : (
                    rows.map((row) => (
                        <Chip
                            key={row.label}
                            label={`${formatChannelLabel(row.label)} · ${row.count}`}
                            sx={{ fontWeight: 800, ...getChannelChipStyles(row.label) }}
                        />
                    ))
                )}
            </Stack>
        </Paper>
    );
}
